import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CategoryInterface } from "src/app/interfaces/lobby.interface";
import { ControlHelperService } from "src/app/services/control/control-helper.service";
import { ControlService } from "src/app/services/control/control.service";
import { StructureService } from "src/app/services/structure/structure.service";

@Injectable({
    providedIn: 'root'
})
export class NavigationBarService {

    constructor(
        private control: ControlService,
        private controlHelper: ControlHelperService,
        private structure: StructureService,
    ) {
    }

    public getNavigationBar(placement: string): Observable<CategoryInterface[]> {
        return this.structure.getCategoriesByPlacement(placement).pipe(
            map(cat => {
                return cat ?? [];
            })
        );
    }

    public selectLink(link: CategoryInterface) {
        this.control.selectCategory(link);
        this.controlHelper.setActiveLobbyCategory(link);
    }

}